module.exports = __webpack_public_path__ + "static/team15-cf84c804831b7bb73c6af19b34e51feb.jpg";